import { render, staticRenderFns } from "./ExpenseView.vue?vue&type=template&id=d2632e54&"
import script from "./ExpenseView.vue?vue&type=script&lang=js&"
export * from "./ExpenseView.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseView.vue?vue&type=style&index=0&id=d2632e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports